import { Box, Button, Flex, HStack, Link, Stack, useBreakpointValue, VStack } from '@chakra-ui/react';
import { Image } from '@common/components/Image';
import { FontFamily } from '@common/theming/Fonts';
import * as React from 'react';
import { TextBlock } from '../../common/components/TextBlock';
import { ROUTES } from '../../config';
import { SignInForm } from './components/SignInForm';

export const SignInPage = () => (
  <Flex minH={{ base: '100%', md: '100vh' }} backgroundColor="#263243" w="100%">
    <Flex mx="auto" width="full">
      <VStack
        flex="1"
        display={{ base: 'none', md: 'flex' }}
        alignItems="flex-end"
        boxSizing="border-box"
        px={[0, 0, '25px', '100px']}>
        <Flex direction="column" px={{ base: '4', md: '8' }} height="full" color="on-accent" maxW="md">
          <Flex align="center" h="24">
            <Image image="logo-white" w={150} />
          </Flex>
          <Flex flex="1" align="center">
            <Stack spacing="8">
              <Stack spacing="6">
                <TextBlock
                  fontFamily={FontFamily.DM_SERIF_DISPLAY_REGULAR}
                  letterSpacing={'0.48px'}
                  fontSize="64px"
                  lineHeight={'0.8'}
                  size={useBreakpointValue({ md: 'lg', xl: '2xl' })}>
                  <TextBlock fontFamily={FontFamily.DM_SERIF_DISPLAY_REGULAR} fontSize="64px" as="span" color="white">
                    Invest in{' '}
                  </TextBlock>
                  <Box
                    as="span"
                    background="linear-gradient(180deg, #63AAFF 0%, #63AAFF 35%, #C7E0FF 60%, #FFD698 85%, #C4A8FF 100%)"
                    backgroundClip="text">
                    real estate
                  </Box>
                  <TextBlock as="span" fontFamily={FontFamily.DM_SERIF_DISPLAY_REGULAR} fontSize="64px" color="white">
                    {' '}
                    the smart way.
                  </TextBlock>
                </TextBlock>
                <TextBlock color="white" fontSize="lg" maxW="md" fontWeight="medium">
                  <Link color="white" href={ROUTES.signup} textDecoration={'underline'}>
                    Create an account
                  </Link>{' '}
                  and start building wealth in real estate with a little help from the experts.
                </TextBlock>
              </Stack>
              <HStack spacing="4">
                <Button
                  variant="outline"
                  size={'md'}
                  colorScheme="white"
                  onClick={() => window.open('https://www.concreit.com/', '_blank')}
                  p={'25px'}
                  fontWeight={'normal'}
                  fontFamily={FontFamily.HELVETICA_NOW_BOLD}>
                  Learn more
                </Button>
              </HStack>
            </Stack>
          </Flex>
          <Flex align="center" h="24" flexDir={'column'} alignItems={'flex-start'}>
            <TextBlock color="on-accent-subtle" fontSize="sm">
              © {new Date().getFullYear()} Concreit Inc. All rights reserved.
            </TextBlock>
            <TextBlock color="on-accent-subtle" fontSize="xs">
              Designed & developed in Seattle.
            </TextBlock>
          </Flex>
        </Flex>
      </VStack>
      <VStack
        boxSizing="border-box"
        px={[0, 0, '25px', '100px']}
        flex="1"
        backgroundColor="white"
        height="100%"
        justifyContent={'center'}
        alignItems={['center', 'center', 'center', 'flex-start']}>
        <SignInForm px={{ base: '4', md: '8' }} py={{ base: '12', md: '48' }} width="full" maxW="md" />
        <Flex align="center" h="24" flexDir={'column'} alignItems={'center'} display={['flex', 'flex', 'none', 'none']}>
          <TextBlock color="gray.400" fontSize="sm">
            © {new Date().getFullYear()} Concreit Inc. All rights reserved.
          </TextBlock>
          <TextBlock color="gray.200" fontSize="xs">
            Designed & developed in Seattle.
          </TextBlock>
        </Flex>
      </VStack>
    </Flex>
  </Flex>
);
